import type { Element, Node } from '@xmldom/xmldom'

// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
const ELEMENT_NODE = 1

export const xmlNodeIsElement = (n: Node): n is Element => n.nodeType === ELEMENT_NODE

interface TypedXmlAttributes {
	[name: string]: string|boolean
}

export const getTypedXmlAttributes = (node: Element): TypedXmlAttributes => {
	const attributes: TypedXmlAttributes = {}
	if(node.attributes?.length > 0) {
		for(let attrIdx in node.attributes) {
			const { name, value } = node.attributes[attrIdx]
			let newValue: string|boolean = value
			switch(newValue) {
				case "true":
					newValue = true
					break
				case "false":
					newValue = false
					break
			}
			attributes[name] = newValue
		}
	}
	return attributes
}

interface StringXmlAttributes {
	[name: string]: string
}

export const getStringXmlAttributes = (node: Element): StringXmlAttributes => {
	const attributes: StringXmlAttributes = {}
	if(node.attributes?.length > 0) {
		for(let attrIdx in node.attributes) {
			const { name, value } = node.attributes[attrIdx]
			attributes[name] = value
		}
	}
	return attributes
}

export const stringToBool = (value: string|null): boolean => {
	if(!value) {
		return false
	}
	return value.toLowerCase() === 'true'
}
